// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"04fb2478","455":"8072b7c4","488":"66c316c5","977":"6a74a750"}[chunkId] + ".chunk.js";
};